import { Text, View } from "@react-pdf/renderer";

import { styles } from "../../Tables";

export const TableRowDobavljaciEvdListaEvidencijaHeader: React.FC<{
  naziv: string;
  address: string;
  phoneNumber: string;
  idTax: string;
  pdvTax: string;
  productType: string;
}> = ({ naziv, address, phoneNumber, idTax, pdvTax, productType }) => (
  <View style={styles.tableRow}>
    <View style={styles.tableCol}>
      <Text style={styles.tableCell}>{naziv}</Text>
    </View>
    <View style={styles.tableCol}>
      <Text style={styles.tableCell}>{address}</Text>
    </View>
    <View style={styles.tableCol}>
      <Text style={styles.tableCell}>{phoneNumber}</Text>
    </View>
    <View style={styles.tableCol}>
      <Text style={styles.tableCell}>{idTax}</Text>
    </View>
    <View style={styles.tableCol}>
      <Text style={styles.tableCell}>{pdvTax}</Text>
    </View>
    <View style={styles.tableCol}>
      <Text style={styles.tableCell}>{productType}</Text>
    </View>
  </View>
);

export const TableRowDobavljaciEvdListaEvidencija: React.FC<{
  naziv: string;
  address: string;
  phoneNumber: string;
  idTax: string;
  pdvTax: string;
  productType: string;
}> = ({ naziv, address, phoneNumber, idTax, pdvTax, productType }) => (
  <View style={styles.tableRow} wrap={false}>
    <View style={styles.tableCol}>
      <Text style={styles.tableCell}>{naziv}</Text>
    </View>
    <View style={styles.tableCol}>
      <Text style={styles.tableCell}>{address}</Text>
    </View>
    <View style={styles.tableCol}>
      <Text style={styles.tableCell}>{phoneNumber}</Text>
    </View>
    <View style={styles.tableCol}>
      <Text style={styles.tableCell}>{idTax}</Text>
    </View>
    <View style={styles.tableCol}>
      <Text style={styles.tableCell}>{pdvTax}</Text>
    </View>
    <View style={styles.tableCol}>
      <Text style={styles.tableCell}>{productType}</Text>
    </View>
  </View>
);
